import React from 'react'

import { Step } from 'react-joyride'

export const getSteps = (t: any, width: number): Step[] => [
    {
        title: t('1thStepTitle'),
        placement: 'center',
        target: 'body',
        content: (
            <>
                <div>{t('1thStepRow')}</div>
                <div>{t('1thStepRow2')}</div>
            </>
        ),
    },
    {
        title: t('2thStep'),
        placement: width < 1330 ? 'top' : 'right',
        target: '.second-step',
        content: '',
    },
    {
        title: t('3thStep'),
        placement: 'left',
        target: '.third-step',
        content: '',
    },
    {
        title: t('4thStep'),
        placement: width < 1330 ? 'top' : 'right',
        target: '.fourth-step',
        content: '',
    },
    {
        title: t('5thStep'),
        placement: width < 1330 ? 'top' : 'right',
        target: '.fifth-step',
        content: '',
    },
    { title: t('6thStep'), placement: 'center', target: 'body', content: '' },
    {
        title: t('7thStep'),
        placement: 'bottom',
        target: '#seventh-step',
        content: '',
    },
    {
        title: t('8thStep'),
        placement: 'right',
        target: '#generalDesign',
        content: '',
    },
    {
        title: t('9thStep'),
        placement: 'right',
        target: '#ownDesign',
        content: '',
    },
    {
        title: t('10thStep'),
        placement: 'right',
        target: '#welcomeScreen',
        content: '',
    },
    {
        title: t('11thStep'),
        placement: 'bottom',
        target: '.welcome-screen__inputs',
        content: '',
    },
    { title: t('12thStep'), placement: 'right', target: '#icon', content: '' },
    {
        title: t('13thStep'),
        placement: 'bottom',
        target: '.design-icon',
        content: '',
    },
    {
        title: t('14thStep'),
        placement: 'right',
        target: '.menu-pannel--subcategories',
        content: '',
    },
    {
        title: t('15thStep'),
        placement: 'right',
        target: '#fifteenth-step',
        content: '',
    },
    {
        title: t('16thStep'),
        placement: 'top',
        target: '#sixteenth-step',
        content: '',
    },
    {
        title: t('17thStep'),
        placement: 'right',
        target: '#generalSettings',
        content: '',
    },
    {
        title: t('18thStep'),
        placement: 'right',
        target: '#factivation',
        content: '',
    },
    {
        title: t('19thStep'),
        placement: 'right',
        target: '#userManagement',
        content: '',
    },
    {
        title: t('20thStep'),
        placement: 'bottom',
        target: '.build-actions__buttons',
        content: '',
    },
    {
        title: t('21thStep'),
        placement: 'right',
        target: '#twentieth-step',
        content: '',
    },
    {
        title: t('22thStep'),
        placement: 'right',
        target: '.new-loader__wrapper',
        content: '',
    },
]
